<template>
    <div :class="classList" v-on:click.self="closeModal">
        <div class="modal--base">
            <button
                v-if="displayCloseButton"
                class="modal--base-close icon closeModalIcon"
                @click="closeModalEvent"></button>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'BaseModal',
        mixins: [],
        props: {
            displayCloseButton: {
                default: true,
                type: Boolean,
            },
        },
        computed: {
            ...mapGetters({
                modal: 'modal/getModal',
            }),
            ...mapState('modal', {
                additionalClasses: (state) => state.additionalClasses,
                modalCloseEnabled: (state) => state.modalCloseEnabled,
            }),
            classList() {
                return ['modal--base-wrapper', this.additionalClasses];
            },
        },
        methods: {
            closeModalEvent: function (e) {
                e.preventDefault();
                this.closeModal();
                this.$emit('closeModalEvent');
            },
            closeModal() {
                if (this.modalCloseEnabled) {
                    this.$store.dispatch('modal/setIsShown', false);
                }
            },
        },
    };
</script>
